import React from 'react';
import { Spinner, Table } from 'react-bootstrap'

import DefaultButton from 'components/mycomponents/DefaultButton';

const Data = ({
    dataMain,
    actionDetail,
    actionEdit,
    actionDelete,
    numberStart,
    isLoading
}) => {
    return (
        <Table responsive striped hover bordered size="sm">
            <thead>
                <tr>
                    <th scope="col">No</th>
                    <th scope="col">Nama</th>
                    <th scope="col">URL</th>
                    <th scope="col">Ikon</th>
                    <th className="text-end" scope="col" width="10%">
                        Aksi
                    </th>
                </tr>
            </thead>
            <tbody>
                {
                    isLoading ? (<tr>
                        <td colSpan={6} align="center" valign="middle">
                            <Spinner animation="border  " className="me-2" />
                            <span className="fs-4">Loading ...</span>
                        </td>
                    </tr>) :
                    dataMain ? dataMain.map((val, idx) => {
                        return (
                            <tr key={idx}>
                                <td>{numberStart + 1 + idx}</td>
                                <td>{val.vcname}</td>
                                <td>{val.vcaction}</td>
                                <td>{val.vcicon}</td>
                                <td className="text-end">
                                    <DefaultButton icon="info" title="Detail Data" variant="action" className="p-0 me-3" clickAction={actionDetail} clickParam={val.intid} />
                                    <DefaultButton icon="edit" title="Edit" variant="action" className="p-0 me-3" clickAction={actionEdit} clickParam={val.intid} />
                                    <DefaultButton icon="trash-alt" title="Delete" variant="action" className="p-0" clickAction={actionDelete} clickParam={val.intid} />
                                </td>
                            </tr>
                        );
                    }) : (
                        <tr>
                            <td colSpan={6}>Data Tidak Tersedia.</td>
                        </tr>
                    )
                }
            </tbody>
        </Table>
    );
}

Data.propTypes = {}

export default Data;